import { OVER_UNDER } from '~/apps/product-plus/components/BettingInsights/constants';
import { type MarketClassification } from '~/apps/product-plus/components/BettingInsights/types';
import {
  type BettingSplitsBet,
  type BettingSplitsDrawBet,
  type BettingSplitsTeamBet,
} from '~/apps/product-plus/configuration/types';

export function sortBetsBySequence<M extends MarketClassification>(
  bets: BettingSplitsBet[],
  marketClassification: M,
  marketGenericSequence: M extends Omit<MarketClassification, typeof OVER_UNDER> ? string : never,
): [BettingSplitsBet, BettingSplitsDrawBet | undefined, BettingSplitsBet] {
  switch (marketClassification) {
    case OVER_UNDER: {
      const sequence = OVER_UNDER.split('_');
      bets.sort((a, b) => sequence.indexOf(a.line!.name.toUpperCase()) - sequence.indexOf(b.line!.name.toUpperCase()));

      const [leftBet, rightBet] = bets;

      return [leftBet, undefined, rightBet];
    }
    default: {
      const sequence = marketGenericSequence.split('_');
      const teamBets = bets.filter((bet): bet is BettingSplitsTeamBet => !!bet.teamType);
      const [middleBet] = bets.filter((bet): bet is BettingSplitsDrawBet => !bet.teamType);

      teamBets.sort((a, b) => sequence.indexOf(a.teamType.toUpperCase()) - sequence.indexOf(b.teamType.toUpperCase()));

      const [leftBet, rightBet] = teamBets;

      return [leftBet, middleBet, rightBet];
    }
  }
}
